import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogTitle } from '@material-ui/core/';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CredentialService from '../../../../services/CredentialService/CredentialService';
import { useSetRecoilState} from 'recoil';
import { alertState} from '../../../../recoil-store/recoil-state';
import './ResponseDialog.css';

function ResponseDialog (props) {
    const { t } = useTranslation();
    const [disable, setDisable] = useState(false)
    const setAlert = useSetRecoilState(alertState)
    const handleClose = () => {
        props.setOpen(false);
    };

    const handleAccept = () => {
        handleStatusService(1)
    };

    const handleReject = () => {
        handleStatusService(2)
    };

    const handleStatusService = async (status) => {
        setDisable(true)
        const description = document.getElementById('filled-multiline-static').value;
        const response = await CredentialService.setCredentialStatus(props.clickedItem?.connection_request_id, {
            approve_status: status,
            description
        });
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t(`MESSAGES.CREDENTIAL.CONNECTION-REQUEST-${response.message}`), severity:response.status ? 'success': 'error' }))
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setDisable(false);
        props.fetchData();
        props.setOpen(false);
    }

    return (
        <Dialog
            id="credential-response-modal"
            data-test="response-dialog"
            open={true}
            onClose={handleClose}
        >
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#001128' }}>
                <div id="about-title">
                    {t('CONTENT.REQUEST-TAB.YOUR-CONNECTION-HAS-BEEN-REQUESTED')}
                    <Button data-test="canceldialog-button" onClick={handleClose}>
                        {t('CONTENT.ABOUT.CLOSE')}
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ marginTop: 10 }}>
                    <span style={{ marginRight: 20 }}>
                        <b>{t('CONTENT.REQUEST-TAB.REQUESTING-USER')} : </b>&nbsp; {props.clickedItem?.requester_full_name}
                    </span>
                    <span style={{ marginLeft: 20 }}>
                        <b>{t('CONTENT.DATATABLE.COLUMNS.CREDENTIAL_NAME')} : </b>&nbsp; {props.clickedItem?.connection_name}
                    </span>
                </div>
                <div style={{ marginTop: 16, marginBottom: 10 }}>
                    <b>{t('CONTENT.REQUEST-TAB.REQUEST-CLOSURE-STATEMENT')} : </b>
                </div>
                <TextField
                    id="filled-multiline-static"
                    autoFocus
                    multiline
                    rows={5}
                    variant="filled"
                    fullWidth
                />
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between', padding: '8px 24px 16px 24px' }}>
                <Button data-test="reject-request" onClick={handleReject} disabled={disable} color="secondary" style={{ textTransform: 'none' }} variant="outlined">
                    {t('CONTENT.REQUEST-TAB.REJECT-REQUEST')}
                </Button>
                <Button data-test="accept-request" onClick={handleAccept} disabled={disable} color="primary" style={{ textTransform: 'none' }} variant="outlined">
                    {t('CONTENT.REQUEST-TAB.ACCEPT-REQUEST')}
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default ResponseDialog;
